import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import { formatDate } from "Utils";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";

import classes from "./DateMessage.scss";

const DateMessage = props => {
  const { date } = props;

  const dateClassesV2 = classNames("text-body-3", classes.dateV2);

  const formattedDate = formatDate({
    date,
    format: DATE_TIME_CONSTANTS.DATE_MESSAGE,
  });

  return (
    <div className={classes.dateContainer}>
      <div className={classes.border} />
      <div className={dateClassesV2}>{formattedDate}</div>
      <div className={classes.border} />
    </div>
  );
};

DateMessage.propTypes = {
  date: PropTypes.string.isRequired, // ISO date string
};

export default DateMessage;
